import { CacheProvider } from '@emotion/react';
import React, { Component } from 'react';
import createCache from '@emotion/cache';

const options = {
  ltr: { key: 'css-en' },
};
export function RtlProvider({ children }) {
  const dir = document.documentElement.dir === 'ar' ? 'rtl' : 'ltr';
  const cache = createCache(options[dir]);
  return <CacheProvider value={cache} children={children} />;
}
